// 混合样式状态
export var STATE_LIST = ['default', 'active', 'selected', 'disabled', 'inactive'];
//# sourceMappingURL=constant.js.map